import React from 'react';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import HowItWorks from './HowItWorks';
import Testimonials from './Testimonials';
import PricingSection from './PricingSection';
import WhatIsMegaLoto from './WhatIsMegaLoto';
import Footer from './Footer';

const LandingVentas = () => {
  return (
    <div className="landing">
      <HeroSection />
      <WhatIsMegaLoto />
      <FeaturesSection />
      <HowItWorks />
      <PricingSection />
      <Testimonials />
      <Footer />
    </div>
  );
};

export default LandingVentas;
